// extracted by mini-css-extract-plugin
module.exports = {"catalogContainer":"catalog_catalogContainer__3FyZp","aviso":"catalog_aviso__2-CJT","catalog":"catalog_catalog__PsxcE"};